import { createContext, useContext } from 'react';
/**
 * Context for providing auth service to the application layer.
 * Must be provided at the app root.
 */
export const AuthServiceContext = createContext(null);
/**
 * Hook to access the auth service from context.
 * Throws if used outside of AuthServiceProvider.
 */
export const useAuthService = () => {
    const authService = useContext(AuthServiceContext);
    if (!authService) {
        throw new Error('useAuthService must be used within an AuthServiceProvider');
    }
    return authService;
};
/**
 * Provider component for the auth service.
 * Wrap your app with this provider and pass in the platform-specific auth service.
 */
export const AuthServiceProvider = AuthServiceContext.Provider;
//# sourceMappingURL=AuthServiceContext.js.map